import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import { CompanySelect } from 'components/inputs';
import React from 'react';
import { ReferenceInput, SelectInput } from 'react-admin';
import { useFormState } from 'react-final-form';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  gridItem: {
    width: '100%',
  },
}));

interface AssignCompanyProductFormProps {
  disabled?: boolean;
}

export const AssignCompanyProductForm: React.FC<AssignCompanyProductFormProps> = ({ disabled = false }) => {
  const classes = useStyles();
  const { values, initialValues } = useFormState();

  return (
    <Grid container spacing={2} className={classes.root}>
      <Grid item sm={12} md={12} className={classes.gridItem}>
        {/* TODO - Incoorect work CompanySelect component - research */}
        <CompanySelect 
          size={"md"}
          source="company_id" 
          filter={{ no_transporters: true }}
          allowEmpty={false}
          disabled={disabled}
          fullWidth
        />
      </Grid>
      
      <Grid item sm={12} md={12} className={classes.gridItem}>
        {values.company_id && (
          <ReferenceInput
            source="product_article_id"
            reference="product-articles"
            label="osfc.storage_ui.assign_form.product"
            fullWidth
            disabled={disabled}
            filter={{ company_id: values.company_id }}
          >
            <SelectInput optionText="product_name" />
          </ReferenceInput>
        )}
      </Grid>
    </Grid>
  );
};